<template>
    <div class="posglobal-spinner-backdrop">
        <div class="spinner-border text-posglobal" role="status">
            <span class="sr-only">Cargando...</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'spinner'
    }
</script>

<style scoped>
    .posglobal-spinner-backdrop {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        z-index: 1000;
        background: rgba(255, 255, 255, 0.85);
    }
    .spinner-border {
        position: absolute;
        top: calc(50% - 20px);
        left: calc(50% - 20px);
    }
</style>
